// extracted by css-extract-rspack-plugin
export default {"organizationNotFound":"OrganizationNotFound_organizationNotFound__AX3VJ"};